import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';

const LanguageSwitcher = ({ position }) => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const direction = i18n.dir();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lang) => {
    setAnchorEl(null);
    if (lang) {
      i18n.changeLanguage(lang);
      localStorage.setItem('language', lang);
    }
  };

  return (
    <Box
      sx={{
        borderRadius: "50px",
        position: position === "fixed" ? "fixed" : "relative",
        m: position === "fixed" ? 2 : 0,
        p: position === "fixed" ?0:2,
        top: position === "fixed" ? 0 : "auto",
        [direction === 'rtl' ? 'left' : 'right']: position === "fixed" ? 10 : "auto",
        color: "white",
        // backgroundColor:"red",
        zIndex: 1000
      }}
    >
      <IconButton onClick={handleClick} sx={{ color: "white" }}>
        <TranslateIcon sx={{ fontSize: '30px', color: "white !important" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        <MenuItem onClick={() => handleClose('en')}>English</MenuItem>
        <MenuItem onClick={() => handleClose('ar')}>العربية</MenuItem>
      </Menu>
    </Box>
  );
};
LanguageSwitcher.propTypes = {
  position: PropTypes.string.isRequired,
};

export default LanguageSwitcher;
